/// <reference path="../../_references.ts" />
module onvio.setup.activities {
    'use strict';
    export interface IActivityProviderService extends bmp.IProvider<cs.IActivityV1Dto> {
        getStatusOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]>;
        getTypeOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]>;
        getClassOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]>;
        getAdminTypeOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]>;
        getRateTypeOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]>;
        getSurchargeMethodOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]>;
        newActivity(): ng.IPromise<cs.IActivityV1Dto>;
    }

    export interface IClientQueryFilter extends cs.IQueryFilter { }
    export class ActivityProvider implements IActivityProviderService {
        static $inject = [
            '$q',
            '$log',
            '$rootScope',
            '$translate',
            'fef.PromiseUtils',
            'fef.Utils',
            'bmTranslateEventUtils',
            'bmpErrorHandler',
            'bmpProviderUtils',
            'csActivityV1'];
        constructor(
            private $q: ng.IQService,
            private $log: ng.ILogService,
            private $rootScope: ng.IRootScopeService,
            private $translate: ng.translate.ITranslateService,
            private promiseUtils: fef.IPromiseUtilsService,
            private utils: fef.IUtilsService,
            private bmTranslateEventUtils: any,
            private errorHandler: bmp.IErrorHandlerService,
            private providerUtils: bmp.IProviderUtilsService,
            private activityV1: cs.IActivityV1Service) { }

        getList(query: IClientQueryFilter) {
            return this.activityV1.postSearch(bmp.PostSearchUtils.convertGetListParamsToSearchParams(query));
        }

        get(id: string): ng.IPromise<cs.IActivityV1Dto> {
            return this.activityV1.get({
                activityId: id
            });
        }

        post(entity: cs.IActivityV1Dto):
            ng.IPromise<cs.IActivityV1Dto> {

            return this.activityV1.post({
                    data: entity
                });
        }

        put(entity: cs.IActivityV1Dto):
            ng.IPromise<cs.IActivityV1Dto> {

                return this.activityV1.put({
                    activityId: entity.id,
                    data: entity
                });
        }

        save(entity: cs.IActivityV1Dto): ng.IPromise<cs.IActivityV1Dto> {
            return this.providerUtils.save(this, entity);
        }

        delete(id: string): ng.IPromise<any> {
            return this.activityV1.delete({ activityId: id });
        }

        getStatusOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]> {
            return this.bmTranslateEventUtils.loadEnd().then(() => {
                var activeText = this.$translate.instant('Core.Enums.ActivityStatus.ACTIVE');
                var inactiveText = this.$translate.instant('Core.Enums.ActivityStatus.INACTIVE');
                return this.promiseUtils.resolvedPromise([
                    {
                        name: activeText,
                        id: 'ACTIVE'
                    },
                    {
                        name: inactiveText,
                        id: 'INACTIVE'
                    }
                ]);
            });
        }

        getTypeOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]> {
            return this.bmTranslateEventUtils.loadEnd().then(() => {
                var timeText = this.$translate.instant('Core.Enums.ActivityType.TIME');
                var expenseText = this.$translate.instant('Core.Enums.ActivityType.EXPENSE');
                return this.promiseUtils.resolvedPromise([
                    {
                        name: timeText,
                        id: 'TIME'
                    },
                    {
                        name: expenseText,
                        id: 'EXPENSE'
                    }
                ]);
            });
        }

        getClassOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]> {
            return this.bmTranslateEventUtils.loadEnd().then(() => {
                var administrativeText = this.$translate.instant('Core.Enums.ActivityClass.ADMINISTRATIVE');
                var billableText = this.$translate.instant('Core.Enums.ActivityClass.BILLABLE');
                var nonbillableText = this.$translate.instant('Core.Enums.ActivityClass.NONBILLABLE');
                return this.promiseUtils.resolvedPromise([
                    {
                        name: administrativeText,
                        id: 'ADMINISTRATIVE'
                    },
                    {
                        name: billableText,
                        id: 'BILLABLE'
                    },
                    {
                        name: nonbillableText,
                        id: 'NONBILLABLE'
                    }
                ]);
            });
        }

        getAdminTypeOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]> {
            return this.bmTranslateEventUtils.loadEnd().then(() => {
                var generalText = this.$translate.instant('Core.Enums.ActivityAdministrativeType.GENERAL');
                var accruableBenefitText = this.$translate.instant('Core.Enums.ActivityAdministrativeType.ACCRUABLEBENEFIT');
                var cpeText = this.$translate.instant('Core.Enums.ActivityAdministrativeType.CPE');
                return this.promiseUtils.resolvedPromise([
                    {
                        name: generalText,
                        id: 'GENERAL'
                    },
                    {
                        name: accruableBenefitText,
                        id: 'ACCRUABLEBENEFIT'
                    },
                    {
                        name: cpeText,
                        id: 'CPE'
                    }
                ]);
            });
        }

        getRateTypeOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]> {
            return this.bmTranslateEventUtils.loadEnd().then(() => {
                var noRateText = this.$translate.instant('Core.Enums.RateType.NORATE');
                var employeeRateText = this.$translate.instant('Core.Enums.RateType.EMPLOYEERATE');
                var fixedRateText = this.$translate.instant('Core.Enums.RateType.FIXEDRATE');
                return this.promiseUtils.resolvedPromise([
                    {
                        name: noRateText,
                        id: 'NORATE'
                    },
                    {
                        name: employeeRateText,
                        id: 'EMPLOYEERATE'
                    },
                    {
                        name: fixedRateText,
                        id: 'FIXEDRATE'
                    }
                ]);
            });
        }

        getSurchargeMethodOptionsAsync(): ng.IPromise<cs.INamedReferenceDto[]> {
            return this.bmTranslateEventUtils.loadEnd().then(() => {
                return this.promiseUtils.resolvedPromise([
                    {
                        name: this.$translate.instant('Core.Enums.ActivitySurchargeMethod.NOSURCHARGE'),
                        id: 'NOSURCHARGE'
                    },
                    {
                        name: this.$translate.instant('Core.Enums.ActivitySurchargeMethod.FIXEDAMOUNT'),
                        id: 'FIXEDAMOUNT'
                    },
                    {
                        name: this.$translate.instant('Core.Enums.ActivitySurchargeMethod.PERUNIT'),
                        id: 'PERUNIT'
                    },
                    {
                        name: this.$translate.instant('Core.Enums.ActivitySurchargeMethod.PERCENT'),
                        id: 'PERCENT'
                    }
                ]);
            });
        }

        newActivity(): ng.IPromise<cs.IActivityV1Dto> {
            return this.activityV1.getDefault({});
        }
    }
    angular.module('onvio.setup.activities.ActivityProvider',
        [
            'pascalprecht.translate',
            'fef',
            'bmpErrorHandler',
            'bmpProviderUtils',
            'bmTranslateEventUtils',
            'csActivityV1'
        ])

        .service('onvio.setup.activities.ActivityProvider', ActivityProvider);
}
